import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    console.log(nextPage);
    switch (curPageId) {
        case 'godt-at-vide':
            nextPage = 'dato';
            break;
        case 'dato':
            nextPage = 'adresse';
            break;
        case 'adresse':
            nextPage = 'hvad-er-der-sket';
            break;
        case 'hvad-er-der-sket':
            nextPage = 'om-genstande';
            break;
        case 'om-genstande':
            nextPage = 'indhentning-af-tilbud';
            break;
        case 'indhentning-af-tilbud':
            nextPage = 'politianmeldelse';

            const isPriceQuotationReceived = getValueOrDefault(
                formConfig,
                formValues,
                'erderindhentetettilbudpudbedringafskaden'
            ).value;
            if (isPriceQuotationReceived === 'Ja') {
                nextPage = 'tilbud-og-pris';
            }

            break;
        case 'tilbud-og-pris':
            nextPage = 'politianmeldelse';
            break;
        case 'politianmeldelse':
            nextPage = 'dokumentation';

            const isPoliceContacted = getValueOrDefault(formConfig, formValues, 'policeContacted').value;
            if (isPoliceContacted === 'Y') {
                nextPage = 'samtykke';
            }

            break;
        case 'samtykke':
            nextPage = 'dokumentation';
            break;

        case 'dokumentation':
            nextPage = 'forsikringsmaegler';
            break;
        case 'forsikringsmaegler':
            nextPage = 'om-virksomheden';
            break;

        case 'om-virksomheden':
            nextPage = 'andet-selskab';
            break;

        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                nextPage = 'hvilket-selskab';
            } else {
                nextPage = 'om-dig';
            }
            break;

        case 'hvilket-selskab':
            nextPage = 'om-dig';
            break;
        case 'om-dig':
            nextPage = 'resume';
            break;
        case 'resume':
            nextPage = undefined;
            break;
        default:
            console.log('# curPageId=', curPageId);
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
